import { render } from "./OpenIcon.vue?vue&type=template&id=ecc04e02&scoped=true"
import script from "./OpenIcon.vue?vue&type=script&lang=js"
export * from "./OpenIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc04e02"]])

export default __exports__